/* globalmodule */
/* homemodule */
define('../src/sublayouts/m20-notification/m20-notification',['jquery'],
    function($, utils) {

        'use strict';

        var Notification = function($component) {

            this.$component = $component;
        };

        Notification.prototype.init = function() {

            var _this = this;

            this.timeout = this.$component.data('timeout');
            this.repeat = this.$component.data('time-repeat');
            this.permanent = this.$component.hasClass('show-permanent') ? true : false;
            this.$closenew = this.$component.find('.m20-new-close');
            this.$closenewstyle = this.$component.find('.m20-newstyle-close');
            this.$close = this.$component.find('.m20-notification__dismiss');
            this.repetTime = this.repeat * 60 * 1000;
            this.cookieName = this.$component.data('cookie-name');

            // Remove special characters and spaces
            this.cookieName = this.cookieName.replace(/[^a-zA-Z0-9]/g, '');


            $(window).scroll(function() {
                var scroll = $(window).scrollTop();
                _this.$component.addClass('fixed');
            });

            if(_this.$component.hasClass('sap-maintenance-notification')){
                var x = _this.readCookie(this.cookieName);
                if (x === null) {
                    _this.notifictionShow();
                }
            }else{
                _this.notifictionShow();
            }
                

            if (!this.permanent) {
                setInterval(
                    function() {
                        var x = _this.readCookie(this.cookieName);

                        if (x === null) {
                            _this.notifictionShow()

                        }
                    }, this.repetTime)
            }

            this.$closenew.on('click', function() {
                //console.log('click')
                _this.$component.removeClass('shown')
            });

            this.$closenewstyle.on('click', function() {
                //console.log('click')
                _this.$component.removeClass('shown');
                $('.m12-bar').removeAttr('style');
                if (_this.$component.hasClass('notification-newstyle') && !_this.$component.hasClass('sap-maintenance-notification')) {
                    _this.$component.css('min-height', 0);
                    _this.$component.css('max-height', 0);
                };

                // SAP M notification - setting cookie on hide, once expire notification will show again.
                if(_this.$component.hasClass('sap-maintenance-notification')){
                    var datenow = new Date();
                    datenow.setTime(datenow.getTime() + (24 * 60 * 60 * 1000)); // Convert hours to milliseconds
                    var expires = "expires=" + datenow.toUTCString();
                    document.cookie =  this.cookieName + " = " + this.cookieName + ";" + expires + ";path=/";
                    _this.$component.hide()
                }
            });

            this.$close.one('click', function(ev) {
                ev.preventDefault();
                _this.$component.fadeOut(function() {
                    _this.$component.remove();
                });
            });

            this.listenToScroll();

            if (this.$component.hasClass('m20-notification--marquee')) {

                $('.m12-masthead').addClass('m20marquee');

                setTimeout(function () {
                    $('.mobile-menu').attr('m20marquee', "");
                }, 500);

                $(window).off('resize.m20').on('resize.m20',function () {
                    setTimeout(function () {
                        $('.mobile-menu').attr('m20marquee', "");
                    }, 500);
                });

                // var intervalId = setInterval(function() {
                //     var m20clone2 = _this.$component.find('.m20-notification-2').clone()

                //     _this.$component.find('.m20-notification-2:first-child').remove();
                //     _this.$component.find('.grid__row').append(m20clone2);
                // }, parseInt(_this.$component.attr('data-marquee-duration'))*1000);
            };

            this.$component.find('[m20-close="true"]').off('click.m20').on('click.m20', function() {
                _this.$component.hide();
            });

        };

        Notification.prototype.listenToScroll = function() {
            var _this = this,
                offset;

            $('.new-notification').on('posm20check', function() {
                if ($(window).width() <= 1024) {
                    offset = 65;
                } else {
                    offset = 60;
                };
                if ($('.new-notification').hasClass('shown')) {
                    if ($('.m12-bar').hasClass('m12-bar--fixed-new')) {
                        $('.m12-bar--fixed-new').css('top', ($('.new-notification').height() - offset).toString() + 'px');
                    } else {
                        $('.m12-bar--fixed').css('top', $('.new-notification').height().toString() + 'px');
                    }
                };
            });

            $('.notification-newstyle').on('posm20check', function() {
                console.log('posm20check')
                $(this).css({
                    height: '0px',
                    overflow: 'hidden'
                });
            })

            $('.new-notification').on('negm20check', function() {
                $('.m12-bar').removeAttr('style');
            });

            $('.notification-newstyle').on('negm20check', function() {
                $(this).css({
                    height: 'unset',
                    overflow: 'hidden'
                });
                console.log('negm20check')
            })
        };

        Notification.prototype.notifictionShow = function() {
            var _this = this;
            var stay = this.timeout * 1000
            $('.new-notification').addClass('shown')

            // SAP M notification- remove min and max 0 height from the component to show
            if(_this.$component.hasClass('sap-maintenance-notification')){
                _this.$component.show()
            }

            if ($('.new-notification').hasClass('notification-newstyle')) {
                var conHeight = $('.m20-notification-2').height()
                if (conHeight > 60) {
                    var conHeight = conHeight + 10
                }
                $(window).on('resize', function() {
                    $('.new-notification').css('min-height', 'unset');
                    $('.new-notification').css('max-height', 'unset');
                });
                $('.new-notification').css('min-height', 'unset');
                $('.new-notification').css('max-height', 'unset');
            }

            if (this.permanent == true) {
                if(_this.$component.hasClass('sap-maintenance-notification')){
                    
                }else{
                    document.cookie =  this.cookieName + ' = ' + this.cookieName + '; expires=25 Dec 2050 12:00:00 UTC; path=/';
                }
            } else {
                    setTimeout(_this.notifictionHide, stay)
                    _this.createCookie(this.cookieName , this.cookieName, this.repetTime);
            }
        }

        Notification.prototype.createCookie = function(name, value, hours) {
            var expires = "";
            if (hours) {
                var date = new Date();
                date.setTime(date.getTime() + (hours - 10));


                expires = "; expires=" + date.toUTCString();
            };
            document.cookie = name + "=" + value + expires + "; path=/";
        };

        Notification.prototype.readCookie = function() {
            var _this = this,
                nameEQ = this.cookieName + "=";
            
            // SAP M notification - cookie name change
            if(_this.$component.hasClass('sap-maintenance-notification')){
                nameEQ = this.cookieName;
            }

            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {

                var c = ca[i];

                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length)
                };

                if (c.indexOf(nameEQ) == 0) {
                    return true
                };

            }

            return null;
        };

        Notification.prototype.notifictionHide = function() {
            var _this = this;
            //console.log(this.$notification)
            if ($('.new-notification').hasClass('shown')) {
                $('.new-notification').removeClass('shown')
            }
            if ($('.new-notification').hasClass('notification-newstyle')) {
                $('.new-notification').css('min-height', 0);
                $('.new-notification').css('max-height', 0);
            }
            $('.m12-bar').removeAttr('style');
        }

        return Notification;

    });

